import React from 'react';
import { portfolioData } from '../data/mock';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

const BlogSection = () => {
  const { blog } = portfolioData;

  return (
    <section id="blog" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#1a1d29]">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            <span className="text-emerald-400 font-mono text-xl">05.</span> Featured Blog Post
          </h2>
          <div className="h-px bg-gray-700 mt-4"></div>
        </div>

        <Card className="bg-[#0f1419] border-gray-800 hover:border-emerald-500/50 transition-all duration-300 overflow-hidden">
          <div className="p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center">
                <BookOpen size={24} className="text-emerald-400" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">{blog.featured.title}</h3>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              {blog.featured.description}
            </p>
            <Button
              variant="outline"
              className="border-2 border-emerald-500 text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300"
              onClick={() => window.open(blog.featured.link, '_blank')}
            >
              Read Article
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </div>
        </Card>

        <p className="text-center text-gray-500 mt-8">
          More articles coming soon...
        </p>
      </div>
    </section>
  );
};

export default BlogSection;
